import React from "react";
import { connect } from "react-redux";
import {Dropdown} from 'semantic-ui-react';
// import DesignRules from './DesignRules';
import api from "../../../api";
import './TranScriptChat.css';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { Message } from "semantic-ui-react";
import {
    setPageTitle,
    toggleNavigation,
    setMessage,
    setBreadCrum,
} from "../../../store/Page";
import DateRangePicker from 'react-bootstrap-daterangepicker';

import 'bootstrap-daterangepicker/daterangepicker.css';
const queryString = require("query-string");

class ChatFilter extends React.Component {

    #oneMonthAgo = moment().subtract(1, 'month').format('MM/DD/YYYY');
    #today =moment().format('MM/DD/YYYY');
   

constructor(props) {
    super(props);
   
    this.state = {
        chatstatus: 'all',
        daterange: 'daterange',
        selectedtext:this.#oneMonthAgo +" - " + this.#today,
        rangepicker:true,
        csvdata:[],
        serach:'',
        filter:'',
        daterangeerror:'',
        workspace_id: props.selectedWorkspace || ''
    };
    
 

    }

notify = (msg) =>  toast(msg, {
    position: 'top-right',
    autoClose: 5000,
    type:'error',
  });

chatStatusChange=(e)=>{
    this.setState({
        chatstatus:e.target.value
    })
    
        this.props.onSubmitFilter('chatstatus',e.target.value);
    
    
}

handleChange=(e)=>{
    this.setState({
        serach:e.target.value
    })
    
}
handleSubmit=(e)=>{
    e.preventDefault();
    this.props.onSubmitFilter('q',this.state.serach);
}
chatTimeChange=(e)=>{
    this.setState({
        chatstatus:e.target.value
    })
    if(e.target.value=='daterange'){
        this.setState({
            rangepicker:true,
            daterange:e.target.value
        },function(){
           
            document.getElementById('calldatepicker').click();
         //  setTimeout(()=>{
           let allels= document.querySelectorAll(".daterangepicker.ltr.show-calendar.opensright");
           allels.forEach(element => {
            element.style.top="348.875px";
            element.style.left="auto";
            element.style.right="40px";
            element.className+=" custum-yr-daterangepickercss";
           });
         //  },100);
        })
       
    }else{
        this.setState({rangepicker:false,daterange:e.target.value});
        this.props.onSubmitFilter('chatfrequency',e.target.value);
    }
}
handleStatusChange=(e)=>{
    this.setState({
        chatstatus:e.target.value
    })
    this.props.onSubmitFilter('chatstatus',e.target.value);
}
dateSelectCallback=(event, picker)=>{
    let allels= document.querySelectorAll(".daterangepicker.ltr.show-calendar.opensright");
    allels.forEach(element => {
     element.style.top="348.875px";
     element.style.left="auto";
     element.style.right="40px";
     element.className+=" custum-yr-daterangepickercss";
    });
}

applyDateRange=(event, picker)=>{
    var end = moment(picker.endDate); 
    var now = moment(picker.startDate);
    var duration = end.diff(now,'days');
    if(duration<=365){
        this.setState({
            'selectedtext':picker.startDate.format('MM/DD/YYYY') +" - " + picker.endDate.format('MM/DD/YYYY')
        });
        let range={};
        range['chatfrequency']='daterange'
        range['startdaterange']=picker.startDate.format('MM/DD/YYYY')
        range['enddaterange']=picker.endDate.format('MM/DD/YYYY')
         
        this.props.onSubmitFilterDateReange(range);
    }else{
        this.notify("Select a date-range of 1 year or less.");
         document.getElementById('calldatepicker').click();
    }        
    
    
}
handleClick = (e) => {
    this.datepicker.click();
  }
  onchangedates=(start, end, label)=>{
        console.log(start.format('MM/DD/YYYY'), end.format('MM/DD/YYYY'), label,"changedates");
  }

  workspaceOption = () => {
    let list = this.props.workspaceList.map((workspace, index) => {
        return {
            key: index,
            text: workspace.name,
            value: workspace.auto_id
        }
    });
    if(list.length>0){
        list.unshift({
            key: 'all',
            text: 'All Workspaces',
            value: ''
        });
    }
    return list;
}

handleWorkspaceSelect=(e, { value }) => {
    this.setState({workspace_id: value});
    this.props.onSubmitFilter('workspace_id',value);
}



componentDidUpdate(prevProps) {
    if (prevProps.selectedWorkspace !== this.props.selectedWorkspace && this.props.selectedWorkspace !== this.state.workspace_id) {
        this.setState({ workspace_id: this.props.selectedWorkspace || '' });
    }
}

render() {
    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    let final=month+"/"+date+"/"+year;
    
    return (
        <div className="kt-portlet__body px-0" style={{paddingTop:0}}>


<div className="kt-form kt-form--label-right kt-margin-t-20 kt-margin-b-10">

    <div className="col-xl-12 order-2 order-xl-1">
        <div className="row">
            <div className="col-xl-12">
                <div className="row align-items-center" style={{float:"right",marginRight:"20px"}}>
                {this.props.workspaceList && !this.props.isPLG &&<div style={{marginRight:"10px",display:"flex",alignItems:"center"}}>
                    {/* <label>Filter by Workspace</label> */}
                    <Dropdown
                        placeholder='Filter by Workspace'
                        search
                        selection
                        options={this.workspaceOption()}
                        value={this.state.workspace_id}
                        name="workspace_id"
                        onChange={this.handleWorkspaceSelect}
                        clearable
                        id="workspace_id"
                    />
                </div> }
            
                <form id="searchchat" method="post" onSubmit={(e)=>this.handleSubmit(e)}> 
                <div >	
                <div className="kt-input-icon kt-input-icon--right header-search kt-input-icon--right">
                    <input type="text" className="form-control" placeholder="Search..." id="generalSearch" name="q" onChange={(e)=>this.handleChange(e)}/>
                   
                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                    <span><i className="la la-search"></i></span>
                    </span>
                
                </div>
                </div>
                </form>
                  
                   
                    <div className="tbl-header-opt kt-margin-b-20-tablet-and-mobile">
                        <div className="kt-form__group kt-form__group--inline">
                            <div className="kt-form__label">
                                <label></label>
                            </div>
                            <div className="kt-form__control yr-time-ShowHide">
                            <span className="custom-arrow">
                                <select className="form-control bootstrap-select arrow-color mat-style yr-time-ShowHide" value={this.state.daterange} name="chatfrequency" id="kt_form_type" onChange={(e)=>this.chatTimeChange(e)}>
                                    
                                    <option value="today">Today</option>
                                    <option value="yesterday">Yesterday</option>
                                    <option value="pastsevendays">Past 7 days</option>
                                    <option value="lastthirtydays">Past 30 days</option>
                                    <option value="pastyear">Past Year</option>
                                    {/* <option value="alltime">All Time</option> */}
                                    <option value="daterange">Date Range</option> 
                                </select>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="kt-margin-b-20-tablet-and-mobile">
                        <button type="button" className="btn linear-gradient yr-submitbtn fix-btn-size aichatbtn" disabled={this.props.totalCount==0 ? true:false} onClick={()=>this.props.dowloadcsv()}>
                            {this.props.call_type === "sms" ? "Export SMS CSV" : this.props.call_type === "outbound" ? "Export Outbound CSV" : "Export Inbound CSV"}</button>
                    </div>
                   
                  

                </div>
               
            </div>
           
        </div>

    </div>
    {this.state.rangepicker &&
    <div className="col-xl-12 order-2 order-xl-1">
        <div className="tbl-header-opt-date kt-margin-b-20-tablet-and-mobile yr-d-float-right">
            <div className="kt-form__group kt-form__group--inline">
                <div className="kt-form__label">
                    <label></label>
                </div>

                <DateRangePicker
                    initialSettings={{ startDate: this.#oneMonthAgo,endDate:this.#today }}
                    onApply={(event, picker)=>this.applyDateRange(event, picker)}
                    onEvent={(event,picker)=>this.dateSelectCallback(event, picker)}
                    id="calldatepickerwidget"
                >
                    <div className="showrangepicker">
                      
                   <div className="form-control arrow-color mat-style" id="calldatepicker" style={{cursor:"pointer"}}> {this.state.selectedtext} </div> 
                   </div>
                </DateRangePicker>
               
            </div>
        </div>
       
    </div>
}
{this.props.requestedFiles.length>0  && <div className="downloaddiv" style={{marginTop:'5px',float:'right',marginRight: this.state.rangepicker ? (this.props.call_type === "outbound" ? '133px' : this.props.call_type === "sms" ? '172px' : '144px') : (this.props.call_type === "outbound" ? '508px' : this.props.call_type === "sms" ? '547px' : '520px')}}><a target='_blank' href={this.props.requestedFiles[0].file_path} title="download csv file">{this.props.call_type === "sms" ? "Download SMS Data" : this.props.call_type === "outbound" ? "Download Outbound Data" : "Download Inbound Data"} &nbsp;<i className="fa fa-download"></i></a></div>}

</div>

<ToastContainer />
</div>
);
    }
}
export default ChatFilter